'use strict';

import { Entity } from '../Entity';
import { Agency } from '../Agency/Agency';
import { UserIntegrationProvider } from '../User/UserIntegrationProvider';

export class AgencyIntegrationOAuth extends Entity {
  protected id;
  protected provider;
  protected agency;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    if (data.agency) {
      const agency = new Agency();

      agency.hydrate(data.agency);

      this.agency = agency;
    }

    if (data.provider) {
      const provider = new UserIntegrationProvider();

      provider.hydrate(data.provider);

      this.provider = provider;
    }
  }

  public getProvider() {
    return this.provider;
  }

  public getId() {
    return this.id;
  }
}
